<template>
  <active-client></active-client>
</template>

<script>
import ActiveClient from "@/components/company/clients/ActiveClient";
export default { components: { ActiveClient } };
</script>
